import { useMemo } from 'react';
import { useBindViewer } from '../../hooks/useBindViewer';
import { canViewAiChat } from '../permissions';

export const useAiAssistantPermissions = () => {
  const bindViewer = useBindViewer();

  return useMemo(
    () => ({
      canViewAiChat: bindViewer(canViewAiChat),
    }),
    [bindViewer],
  );
};
